import React from 'react'
import './Widgets.css';
import InfoIcon from '@material-ui/icons/Info';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

function Widgets() {

    const newsArticle = (heading, subtitle) => (
        <div className="widgets__article">
            <div className="widgets__articleLeft">
                <FiberManualRecordIcon/>
            </div>
            <div className="widgets__articleRight">
                <h4>{heading}</h4>
                <p>{ subtitle}</p>
            </div>
        </div>
    )

    return (
        <div className="widgets">
            

            {newsArticle("Anxiety is a natural and normally positive emotion. It is your bodys way of preparing to face a challenge. Without any anxiety, you would have no way of anticipating problems and finding solutions." ,"-Dr Edith Henderson")}
            {newsArticle("Anxiety is a part of life, and it's something that we all experience. The most important thing is to not let it control you." ,"-Unknown")}
            {newsArticle("Anxiety is the gap between now and then." ,"-Shannon L. Alder")}

        </div>
    );
}

export default Widgets;
